export default __webpack_public_path__ + "static/media/united-kingdom.a538b281.png";